export const themeConfig = {
  typography: {
    fontFamily: "'Rubik', sans-serif",
    sizes: {
      h1: {
        fontSize: '2.0rem',
        lineHeight: '3.0rem'
      },
      h2: {
        fontSize: '1.5rem',
        lineHeight: '2.0rem'
      },
      h3: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem'
      },
      subtitle1: {
        fontSize: '1rem',
        lineHeight: '1.5rem'
      },
      subtitle2: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem'
      },
      body1: {
        fontSize: '1rem',
        lineHeight: '1.5rem'
      },
      body2: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem'
      },
      button: {
        fontSize: '1rem',
        lineHeight: '1.5rem'
      },
      caption: {
        fontSize: '0.75rem',
        lineHeight: '1.125rem'
      }
    }
  },
  colors: {
    primary: {
      dark: '#000023',
      main: '#0D284B',
      light: '#3D5077',
      50: '#F2F6FA',
      100: '#E4EBF3',
      200: '#C6D4E3',
      300: '#A4BAD0',
      400: '#7693B3',
      500: '#456B93',
      600: '#0D284B',
      700: '#0A223F',
      800: '#081C36',
      900: '#061528'
    },
    secondary: {
      dark: '#C85759',
      main: '#FF8786',
      light: '#FFB9B6'
    },
    heaven: {
      950: '#030316',
      900: '#141548',
      800: '#2A2C80',
      700: '#4244BE',
      600: '#5C5FFF',
      500: '#7784FF',
      400: '#95A5FF',
      300: '#B7C3FF',
      200: '#DAE1FF',
      100: '#ECF0FF'
    },
    mint: {
      dark: '#56CB83',
      main: '#8BFFB3',
      light: '#BFFFE5'
    },
    grey: {
      900: '#181C22',
      800: '#2F3843',
      700: '#475365',
      600: '#5E6F86',
      500: '#768BA4',
      400: '#91A2B9',
      300: '#ADB9CB',
      200: '#C8D1DC',
      100: '#E2E6EE',
      50: '#F0F2F7'
    },
    success: {
      dark: '#12633D',
      main: '#2FB365',
      light: '#A8E2C2',
      lightest: '#E6F5EC'
    },
    error: {
      dark: '#800D0D',
      main: '#D72638',
      light: '#F4A6AF',
      lightest: '#FBE9E9'
    },
    info: {
      dark: '#1A4F75',
      main: '#339DDF',
      light: '#A7DBF6',
      lightest: '#E6F4FB'
    },
    warning: {
      dark: '#704C00',
      main: '#FFAA00',
      light: '#FFE39A',
      lightest: '#FFF6E6'
    },
    green: {
      50: '#DAFBF0',
      100: '#B9F4DB',
      200: '#9AE0C4',
      300: '#4ECDA6',
      400: '#47BD99',
      500: '#3E9D7B',
      600: '#3E7F67',
      700: '#2F6656',
      800: '#244C40',
      900: '#103328'
    },
    red: {
      50: '#FCEAEB',
      100: '#FADCDD',
      200: '#FFBDBE',
      300: '#FF9496',
      400: '#F06666',
      500: '#EB0F38',
      600: '#CE092D',
      700: '#B30525',
      800: '#9A041F',
      900: '#81031A'
    },
    neutral: {
      dark: '#475365',
      main: '#5E6F86',
      light: '#F0F2F7'
    }
  },
  shadows: {
    100: '0px 2px 4px 0px rgba(0, 0, 0, 0.08)',
    300: '0px 3px 6px 0px rgba(0, 0, 0, 0.08)',
    500: '0px 6px 12px 0px rgba(0, 0, 0, 0.08)',
    700: '0px 12px 24px 0px rgba(0, 0, 0, 0.08)',
    900: '0px 24px 42px 0px rgba(0, 0, 0, 0.08)'
  }
} as const;
